import React from "react";
import ReactDOM from "react-dom/client";
import { useEffect, useState } from "react";



const GivingSpace = () => {
    const [opacity, setOpacity] = useState(0);

    useEffect(() => {
        const handleScroll = () => {
            const scrollY = window.scrollY;
            const fadeStart = 300; // Start fading in at this scroll position
            const fadeEnd = 800;   // Fully visible at this scroll position
            let newOpacity = (scrollY - fadeStart) / (fadeEnd - fadeStart);

            newOpacity = Math.min(1, Math.max(0, newOpacity)); // Clamp between 0 and 1
            setOpacity(newOpacity);
        };

        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);
    return (
        <div class='w-full bg-[url(flexbag-givespace-front.svg)] 
            bg-cover h-[100vh] md:h-[60vh] lg:h-[60vh] xl:h-[100vh] align-middle 
            items-center justify-center flex'
            style={{ opacity }}>

            <p class='font-Unbounded text-primary text-center mx-auto lh-1_2 text-4xl sm:text-[3vw] lg:text-[3vw] xl:text-[3.5vw] sm:w-2/3 lg:w-3/4 xl:w-2/3 md:w-2/3 font-bold sm:font-bold lg:font-[700] xl:font-bold sm:align-middle! pad-l-10! sm:pad-t-[200px]! sm:pad-b-[200px]!
'>
                Giving space to young dreamers
            </p>
        </div>
    )
};
// ✅ Render React Component in Liquid File
const rootEl = document.getElementById("react-giveSpace-images");
if (rootEl) {
    ReactDOM.createRoot(rootEl).render(<GivingSpace />);
}
